const hoverintent = require("hoverintent");
const dropdownMenus = document.querySelectorAll('.has-hoverintent');

dropdownMenus.forEach((el) => {
	const opts = {
		timeout: 100,
		interval: 50
	};

	hoverintent(
		el,
		() => {
			el.classList.add('is-open');
		},
		() => {
			el.classList.remove('is-open');
		}
	).options(opts);
});
